<template>
    <div id="como-funciona">
        <div class="row ml-4">
            <div class="col-12">
                <h2 class="textoTitulo">Consulta e Certidão de Protesto</h2>
            </div>
            <div class="col-10 col-md-7">
                <img src="@/assets/imgs/homeServices/consulta-certidao.png" class="w-100">
            </div>
            <div class="col-11 col-md-7 mt-4">
                <p class="textoP">Consulte gratuitamente se há protesto em aberto no CNPJ ou CPF de seu interesse. Caso precise de algum comprovante formal da situação encontrada, será necessário solicitar uma certidão. Este documento atesta se há ou não algum protesto em aberto no CNPJ ou CPF consultado e, caso haja, constarão nele todos os seus dados, possibilitando a negociação com o credor e emissão da carta de anuência com as informações corretas.</p>
            </div>
        </div>
        <div class="row ml-4 mt-4">
            <div class="col-12">
                <h2 class="textoTitulo">Autorização de cancelamento (Carta de anuência eletrônica)</h2>
            </div>
            <div class="col-10 col-md-7 mt-4">
                <img src="@/assets/imgs/homeServices/autorizacao-cancelamento.png" class="w-100">
            </div>
            <div class="col-11 col-md-7 mt-4">
                <p class="textoP">A anuência de protesto digital pode ser emitida gratuitamente pelo credor de uma dívida protestada autorizando o seu cancelamento pelo cartório competente. Não há necessidade de emissão de carta de anuência física e com reconhecimento de firma. Apenas com assinatura eletrônica (certificado digital) do credor, a anuência eletrônica é gerada e o cartório pode efetuar o cancelamento solicitado.</p>
            </div>
            
        </div>
        <div class="row ml-4">
            <div class="col-12">
                <h2 class="textoTitulo">Cancelamento de protesto</h2>
            </div>
            <div class="col-10 col-md-7 mt-4">
                <img src="@/assets/imgs/homeServices/cancelamento-protesto.png" class="w-100">
            </div>
            <div class="col-11 col-md-7 mt-4">
                <p class="textoP">Consulte se sua dívida paga ou negociada já tem autorização para o cancelamento do protesto. Assim que autorizado pelo credor e realizado o pagamento dos emolumentos, por meio do boleto bancário, o cartório competente efetua o cancelamento.</p>
            </div>
        </div>
        <div class="row" id="ajuda">
            <div class="col-11"><h2 class="textoTituloPrincipal ml-4">Ajuda</h2></div>
        </div>
        <div class="section-ajuda-cards">
            <a href="../pdf/manualCertidao.pdf" target="_blank" class="cardAjuda">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="textoCard text-center m-4">
                                <div>
                                    <img src="@/assets/imgs/homeServices/ajuda/ajuda-card-02.jpg" class="ajuda-card-img"/>
                                    <span class="ajuda-card-text-caller">Como solicitar uma certidão de protesto para qualquer cartório do Brasil.</span>
                                </div>
                            </h2>
                        </div>
                    </div>
                    <div class="ajuda-card-saibamais">
                        <img src="@/assets/imgs/svg/arrow_pre.svg" class="ajuda-card-arrow-pre"/>
                        <p class="text-center mt-2 textoSaibaMais">Saiba mais</p>
                    </div>
                </a>
                <a class="cardAjuda" href="../pdf/manualAnuencia.pdf"  target="_blank">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="textoCard text-center m-4">
                                <div >
                                    <img src="@/assets/imgs/homeServices/ajuda/ajuda-card-03.jpg" class="ajuda-card-img"/>
                                    <span class="ajuda-card-text-caller"> Como o credor poderá autorizar online o cancelamento de protesto.</span>
                                </div>
                            </h2>
                        </div>
                    </div>
                    <div class="ajuda-card-saibamais">
                        <img src="@/assets/imgs/svg/arrow_pre.svg" class="ajuda-card-arrow-pre"/>
                        <p class="text-center mt-2 textoSaibaMais">Saiba mais</p>
                    </div>
                </a>
                <a class="cardAjuda" href="../pdf/manualCancelamento.pdf" target="_blank"> 
                    <div class="row">
                        <div class="col-12">
                            <h2 class="textoCard text-center m-4">
                                <div >
                                    <img src="@/assets/imgs/homeServices/ajuda/ajuda-card-05.png" class="ajuda-card-img"/>
                                    <span class="ajuda-card-text-caller"> Como cancelar o seu protesto com autorização para o cancelamento.</span>
                                    </div>
                            </h2>
                        </div>
                    </div>
                    <div class="ajuda-card-saibamais">
                        <img src="@/assets/imgs/svg/arrow_pre.svg" class="ajuda-card-arrow-pre"/>
                        <p class="text-center mt-2 textoSaibaMais">Saiba mais</p>
                    </div>
                </a>
                <a class="cardAjuda" href="../pdf/ManualdeProtesto.pdf" target="_blank"> 
                    <div class="row">
                        <div class="col-12">
                            <h2 class="textoCard text-center m-4">
                                <div >
                                    <img src="@/assets/imgs/homeServices/ajuda/ajuda-card-04.png" class="ajuda-card-img"/>
                                    <span class="ajuda-card-text-caller"> enviar títulos a protesto.</span>
                                    </div>
                            </h2>
                        </div>
                    </div>
                    <div class="ajuda-card-saibamais">
                        <img src="@/assets/imgs/svg/arrow_pre.svg" class="ajuda-card-arrow-pre"/>
                        <p class="text-center mt-2 textoSaibaMais">Saiba mais</p>
                    </div>
                </a>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.m10{
    margin-top:calc(8%);
}
 .borda{
    border:1px solid;
    border-color: #084f84;
}
.textoTitulo{
    color: #084f84;
    font-size: 28px;
    font-weight: bold;
}
.textoP{
    line-height: 30px;
    font-size: 16px;
}
.divTexto{
    margin-top: 5%;
    margin-left: 5%;
    height: auto;
}
.espacoquadroanterior{
    margin-top: 10%;
}
.textoTituloPrincipal
{
  margin-top:calc(10%);
  color: #084f84;
  font-size: 29px;
  line-height: 25px;
  /* margin-right: 500px; */
  text-align: left;
  font-weight: bold;
}
@media (min-width: 900px) {
  .textoTituloPrincipal
  {
    color: #084f84;
    font-size: 35px;
    padding:2px;
    /* margin-right: 500px; */
    text-align: left;
  }
}
/* .cardAjuda{
  padding: 10px;
  box-shadow: 5px 10px 18px #888888;
  border-radius: 10px;
} */
.textoCard{
    font-size: 20px;
    color: #084f84;
    height:100px;
    line-height: 30px;
}
/* .cardAjuda:hover .textoCard{
   
    color: white;
    text-decoration: underline;
} */
/* .cardAjuda:hover{
    background-color: #084f84;  
} */
/* .cardAjuda:hover .textoSaibaMais{
   
    color: white;

} */
/* .textoSaibaMais{
    text-decoration: underline;
    color: #084f84;
    font-size: 20px;
    font-weight: bold;
} */

/* .cardAjuda:hover a{
    color: white;

} */
/* a{
   color: #084f84;
} */
/* MELHORIA */
.section-ajuda-cards{
    width: 100%;
    margin-top: 20px;
}
.section-ajuda-cards .cardAjuda{
    width: 100%;
    height: auto;
    display: flex;
    flex-flow: column;
    background-color: #EDEEF0;
    margin-bottom: 50px;
    justify-content: space-between;
}
.cardAjuda:hover{
    text-decoration: none;
}
.cardAjuda .textoCard{
    margin: 0 !important;
    display: flex;
    flex-flow: column;
    height: fit-content;
}
.cardAjuda:nth-child(3) .textoCard .ajuda-card-img{
    background-color: #55ffe375;
}
.cardAjuda:nth-child(4) .textoCard .ajuda-card-img{
    background-color: #ff55ff26;
}
.cardAjuda .textoCard .ajuda-card-img{
    width: 100%;
    height: 250px;
    object-fit: cover;
}
.cardAjuda .textoCard .ajuda-card-text-caller{
    padding: 40px 20px;
    display: flex;
    font-size: 19px;
    font-weight: 400;
    text-align: start;
    color: #212529;
}
.ajuda-card-saibamais{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 30px;
    margin-bottom: 20px;
}
.ajuda-card-saibamais .ajuda-card-arrow-pre{
    width: 30px;
    height: 17px;
    margin-right: 10px;
    margin-bottom: 6px;
}
</style>